/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M3.5 7a3.484 3.484 0 0 0 1.7179-.4499l.3645.395.0035.0036 2.665 2.8484A2.9896 2.9896 0 0 0 8 11v4c0 .4094.082.7996.2305 1.1552l-1.7897 1.4317A3.4834 3.4834 0 0 0 4.5 17C2.567 17 1 18.567 1 20.5S2.567 24 4.5 24 8 22.433 8 20.5a3.4835 3.4835 0 0 0-.5146-1.8278l1.6511-1.321A2.987 2.987 0 0 0 11 18h8.7574a3 3 0 0 1 2.1213.8787L24 21V11c0-1.6569-1.3431-3-3-3h-4.25V5.9055C18.0439 5.5725 19 4.3979 19 3c0-1.6568-1.3431-3-3-3s-3 1.3432-3 3c0 1.3979.9561 2.5724 2.25 2.9055V8H11c-.6794 0-1.306.2258-1.8089.6065L6.6829 5.9258l-.3462-.3752A3.4842 3.4842 0 0 0 7 3.5C7 1.567 5.433 0 3.5 0S0 1.567 0 3.5 1.567 7 3.5 7Zm0-1.5c1.1046 0 2-.8954 2-2s-.8954-2-2-2-2 .8954-2 2 .8954 2 2 2ZM13 14c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1Zm4-1c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Zm2 1c.5523 0 1-.4477 1-1s-.4477-1-1-1-1 .4477-1 1 .4477 1 1 1ZM4.5 18.5c1.1046 0 2 .8954 2 2s-.8954 2-2 2-2-.8954-2-2 .8954-2 2-2ZM16 4.5c.8284 0 1.5-.6716 1.5-1.5s-.6716-1.5-1.5-1.5-1.5.6716-1.5 1.5.6716 1.5 1.5 1.5Z"
    clipRule="evenodd"
  />,
  'MenuMessageBrokersFilled'
);
